import { Injectable } from '@angular/core';
import { LocalStorageService, SessionStorageService } from 'ngx-webstorage';
//const { Base64 } = require('js-base64');
import { Base64 } from 'js-base64';
import { EComService } from './ecom-common.service';
@Injectable()
export class EComWebStorage {
  constructor(private localSt: LocalStorageService, private sessionSt: SessionStorageService) {
  }

  clear(key: string, type: string) {
    if (type === 'LOCAL') {
      this.localSt.clear(key);
    } else if (type === 'SESSION') {
      this.sessionSt.clear(key);
    }
  }

  get localSt_YourVersion(): any {
    const encoded = this.localSt.retrieve('localst_YourVersion');
    // let decoded = null;
    // if (encoded) {
    //   decoded = JSON.parse(Base64.decode(encoded));
    // }
    return encoded;
  }
  set localSt_YourVersion(value) {
    //var encoded = Base64.encode(JSON.stringify(value));
    this.localSt.store('localst_YourVersion', value);
  }

  get localSt_user_service_request(): any {
    const encoded = this.localSt.retrieve('localst_userservicerequest');
    let decoded = null;
    if (encoded) {
      decoded = JSON.parse(Base64.decode(encoded));
    }
    return decoded;
  }

  set localSt_user_service_request(value) {
    var encoded = Base64.encode(JSON.stringify(value));
    this.localSt.store('localst_userservicerequest', encoded);
  }

  get localSt_shopping_cart(): any {
    const encoded = this.localSt.retrieve('localst_shoppingCart');
    return encoded ? JSON.parse(Base64.decode(encoded)) : null;
  }

  set localSt_shopping_cart(value) {
    var encoded = Base64.encode(JSON.stringify(value));
    this.localSt.store('localst_shoppingCart', encoded);
  }

  get localSt_ip(): any {
    const encoded = this.localSt.retrieve('localst_ip');
    let decoded = null;
    if (encoded) {
      decoded = JSON.parse(Base64.decode(encoded));
    }
    return decoded;
  }
  set localSt_ip(value) {
    var encoded = Base64.encode(JSON.stringify(value));
    this.localSt.store('localst_ip', encoded);
  }

  get localSt_latlng(): any {
    const encoded = this.localSt.retrieve('localst_latlng');
    let decoded = null;
    if (encoded) {
      decoded = JSON.parse(Base64.decode(encoded));
    }
    return decoded;
  }
  set localSt_latlng(value) {
    var encoded = Base64.encode(JSON.stringify(value));
    this.localSt.store('localst_latlng', encoded);
  }

  get localSt_countrycode(): any {
    const encoded = this.localSt.retrieve('localst_countrycode');
    let decoded = null;
    if (encoded) {
      decoded = JSON.parse(Base64.decode(encoded));
    }
    return decoded;
  }
  set localSt_countrycode(value) {
    var encoded = Base64.encode(JSON.stringify(value));
    this.localSt.store('localst_countrycode', encoded);
  }

  get localSt_name(): any {
    const encoded = this.localSt.retrieve('localst_name');
    let decoded = null;
    if (encoded) {
      decoded = JSON.parse(Base64.decode(encoded));
    }
    return decoded;
  }
  set localSt_name(value) {
    var encoded = Base64.encode(JSON.stringify(value));
    this.localSt.store('localst_name', encoded);
  }

  get localSt_contact(): any {
    const encoded = this.localSt.retrieve('localst_contact');
    let decoded = null;
    if (encoded) {
      decoded = JSON.parse(Base64.decode(encoded));
    }
    return decoded;
  }
  set localSt_contact(value) {
    var encoded = Base64.encode(JSON.stringify(value));
    this.localSt.store('localst_contact', encoded);
  }

  get localSt_client_id(): any {
    return this.localSt.retrieve('localst_clientId');
  }
  set localSt_client_id(value) {
    this.localSt.store('localst_clientId', value);
  }

  get localSt_olar_key(): any {
    return this.localSt.retrieve('localst_olar_key');
  }
  set localSt_olar_key(value) {
    this.localSt.store('localst_olar_key', value);
  }

  get localSt_user_id(): any {
    return this.localSt.retrieve('localst_userid');
  }
  set localSt_user_id(value) {
    this.localSt.store('localst_userid', value);
  }

  //session variables
  get sessionSt_user_order_count_for_discount(): any {
    const encoded = this.sessionSt.retrieve('sessionst_user_order_count_for_discount');
    let decoded = null;
    if (encoded) {
      decoded = JSON.parse(Base64.decode(encoded));
    }
    return decoded;
  }
  set sessionSt_user_order_count_for_discount(value) {
    var encoded = Base64.encode(JSON.stringify(value));
    this.sessionSt.store('sessionst_user_order_count_for_discount', encoded);
  }

  get sessionSt_settings_locations(): any {
    const encoded = this.sessionSt.retrieve('sessionst_settingslocations');
    let decoded = null;
    if (encoded) {
      decoded = JSON.parse(Base64.decode(encoded));
    }
    return decoded;
  }
  set sessionSt_settings_locations(value) {
    var encoded = Base64.encode(JSON.stringify(value));
    this.sessionSt.store('sessionst_settingslocations', encoded);
  }


  get sessionSt_settings_location(): any {
    const encoded = this.sessionSt.retrieve('sessionst_settingslocation');
    let decoded = null;
    if (encoded) {
      decoded = JSON.parse(Base64.decode(encoded));
    }
    return decoded;
  }
  set sessionSt_settings_location(value) {
    var encoded = Base64.encode(JSON.stringify(value));
    this.sessionSt.store('sessionst_settingslocation', encoded);
  }

  get sessionSt_company_settings(): any {
    const encoded = this.sessionSt.retrieve('sessionst_companysettings');
    let decoded = null;
    if (encoded) {
      decoded = JSON.parse(Base64.decode(encoded));
    }
    return decoded;
  }
  set sessionSt_company_settings(value) {
    var encoded = Base64.encode(JSON.stringify(value));
    this.sessionSt.store('sessionst_companysettings', encoded);
  }

  get sessionSt_location_settings(): any {
    const encoded = this.sessionSt.retrieve('sessionst_locationsettings');
    let decoded = null;
    if (encoded) {
      decoded = JSON.parse(Base64.decode(encoded));
    }
    return decoded;
  }
  set sessionSt_location_settings(value) {
    var encoded = Base64.encode(JSON.stringify(value));
    this.sessionSt.store('sessionst_locationsettings', encoded);
  }

  get sessionSt_scanned_table_qr(): any {
    const encoded = this.sessionSt.retrieve('sessionst_scannedtableqr');
    let decoded = null;
    if (encoded) {
      decoded = JSON.parse(Base64.decode(encoded));
    }
    return decoded;
  }
  set sessionSt_scanned_table_qr(value) {
    var encoded = Base64.encode(JSON.stringify(value));
    this.sessionSt.store('sessionst_scannedtableqr', encoded);
  }

  get sessionSt_locations_home(): any {
    const encoded = this.sessionSt.retrieve('sessionst_locations_home');
    let decoded = null;
    if (encoded) {
      decoded = JSON.parse(Base64.decode(encoded));
    }
    return decoded;
  }
  set sessionSt_locations_home(value) {
    var encoded = Base64.encode(JSON.stringify(value));
    this.sessionSt.store('sessionst_locations_home', encoded);
  }


  get sessionSt_merchant_promos(): any {
    const encoded = this.sessionSt.retrieve('sessionst_merchant_promo');
    let decoded = null;
    if (encoded) {
      decoded = JSON.parse(Base64.decode(encoded));
    }
    return decoded;
  }
  set sessionSt_merchant_promos(value) {
    var encoded = Base64.encode(JSON.stringify(value));
    this.sessionSt.store('sessionst_merchant_promo', encoded);
  }

  get sessionSt_home_page_index(): any {
    const encoded = this.sessionSt.retrieve('sessionst_home_page_index');
    let decoded = null;
    if (encoded) {
      decoded = JSON.parse(Base64.decode(encoded));
    }
    return decoded;
  }
  set sessionSt_home_page_index(value) {
    var encoded = Base64.encode(JSON.stringify(value));
    this.sessionSt.store('sessionst_home_page_index', encoded);
  }

  get sessionSt_location_selected(): any {
    const encoded = this.sessionSt.retrieve('sessionst_locationselected');
    let decoded = null;
    if (encoded) {
      decoded = JSON.parse(Base64.decode(encoded));
    }
    return decoded;
  }
  set sessionSt_location_selected(value) {
    var encoded = Base64.encode(JSON.stringify(value));
    this.sessionSt.store('sessionst_locationselected', encoded);
  }

  get sessionSt_searched_item(): any {
    const encoded = this.sessionSt.retrieve('sessionst_searched_item');
    let decoded = null;
    if (encoded) {
      decoded = JSON.parse(Base64.decode(encoded));
    }
    return decoded;
  }
  set sessionSt_searched_item(value) {
    var encoded = Base64.encode(JSON.stringify(value));
    this.sessionSt.store('sessionst_searched_item', encoded);
  }

  get sessionSt_orderlocation_details(): any {
    const encoded = this.sessionSt.retrieve('sessionst_orderlocationdetails');
    let decoded = null;
    if (encoded) {
      decoded = JSON.parse(Base64.decode(encoded));
    }
    return decoded;
  }
  set sessionSt_orderlocation_details(value) {
    var encoded = Base64.encode(JSON.stringify(value));
    this.sessionSt.store('sessionst_orderlocationdetails', encoded);
  }

  get sessionSt_service_active_id(): any {
    return this.sessionSt.retrieve('sessionst_serviceactiveid');
  }
  set sessionSt_service_active_id(value) {
    this.sessionSt.store('sessionst_serviceactiveid', value);
  }

  get sessionSt_table_id(): any {
    return this.sessionSt.retrieve('sessionst_serviceactiveid');
  }
  set sessionSt_table_id(value) {
    this.sessionSt.store('sessionst_serviceactiveid', value);
  }

  get sessionSt_page_reload(): any {
    return this.sessionSt.retrieve('sessionst_reload');
  }
  set sessionSt_page_reload(value) {
    this.sessionSt.store('sessionst_reload', value);
  }

  get sessionSt_olar_discounts(): any {
    const encoded = this.sessionSt.retrieve('sessionst_olar_discounts');
    let decoded = null;
    if (encoded) {
      decoded = JSON.parse(Base64.decode(encoded));
    }
    return decoded;
  }
  set sessionSt_olar_discounts(value) {
    var encoded = Base64.encode(JSON.stringify(value));
    this.sessionSt.store('sessionst_olar_discounts', encoded);
  }

  get sessionSt_frompage(): any {
    const encoded = this.sessionSt.retrieve('sessionst_frompage');
    let decoded = null;
    if (encoded) {
      decoded = JSON.parse(Base64.decode(encoded));
    }
    return decoded;
  }
  set sessionSt_frompage(value) {
    var encoded = Base64.encode(JSON.stringify(value));
    this.sessionSt.store('sessionst_frompage', encoded);

  }

  get sessionSt_autoOpenReward(): any {
    const encoded = this.sessionSt.retrieve('sessionst_autoOpenReward');
    let decoded = null;
    if (encoded) {
      decoded = JSON.parse(Base64.decode(encoded));
    }
    return decoded;
  }
  set sessionSt_autoOpenReward(value) {
    var encoded = Base64.encode(JSON.stringify(value));
    this.sessionSt.store('sessionst_autoOpenReward', encoded);

  }

  get sessionSt_giftCardFromPage(): any {
    const encoded = this.sessionSt.retrieve('sessionSt_giftCardFromPage');
    let decoded = null;
    if (encoded) {
      decoded = JSON.parse(Base64.decode(encoded));
    }
    return decoded;
  }
  set sessionSt_giftCardFromPage(value) {
    var encoded = Base64.encode(JSON.stringify(value));
    this.sessionSt.store('sessionSt_giftCardFromPage', encoded);

  }

  get sessionSt_topage(): any {
    const encoded = this.sessionSt.retrieve('sessionst_topage');
    let decoded = null;
    if (encoded) {
      decoded = JSON.parse(Base64.decode(encoded));
    }
    return decoded;
  }
  set sessionSt_topage(value) {
    var encoded = Base64.encode(JSON.stringify(value));
    this.sessionSt.store('sessionst_topage', encoded);

  }

  get sessionSt_service_type(): any {
    const encoded = this.sessionSt.retrieve('sessionst_servicetype');
    let decoded = null;
    if (encoded) {
      decoded = JSON.parse(Base64.decode(encoded));
    }
    return decoded;
  }
  set sessionSt_service_type(value) {
    var encoded = Base64.encode(JSON.stringify(value));
    this.sessionSt.store('sessionst_servicetype', encoded);
  }

  get sessionSt_settings(): any {
    const encoded = this.sessionSt.retrieve('sessionst_settings');
    let decoded = null;
    if (encoded) {
      decoded = JSON.parse(Base64.decode(encoded));
    }
    return decoded;
  }
  set sessionSt_settings(value) {
    var encoded = Base64.encode(JSON.stringify(value));
    this.sessionSt.store('sessionst_settings', encoded);
  }


  get sessionSt_qr_paymentmode(): any {
    const encoded = this.sessionSt.retrieve('sessionst_qrpaymentmode');
    let decoded = null;
    if (encoded) {
      decoded = JSON.parse(Base64.decode(encoded));
    }
    return decoded;
  }
  set sessionSt_qr_paymentmode(value) {
    var encoded = Base64.encode(JSON.stringify(value));
    this.sessionSt.store('sessionst_qrpaymentmode', encoded);
  }


  get sessionSt_scanned_dinein_table(): any {
    const encoded = this.sessionSt.retrieve('sessionst_scanneddineintable');
    let decoded = null;
    if (encoded) {
      decoded = JSON.parse(Base64.decode(encoded));
    }
    return decoded;
  }
  set sessionSt_scanned_dinein_table(value) {
    var encoded = Base64.encode(JSON.stringify(value));
    this.sessionSt.store('sessionst_scanneddineintable', encoded);
  }

  get sessionSt_scanned_area_room(): any {
    const encoded = this.sessionSt.retrieve('sessionst_scannedarearoom');
    let decoded = null;
    if (encoded) {
      decoded = JSON.parse(Base64.decode(encoded));
    }
    return decoded;
  }
  set sessionSt_scanned_area_room(value) {
    var encoded = Base64.encode(JSON.stringify(value));
    this.sessionSt.store('sessionst_scannedarearoom', encoded);
  }

  get sessionSt_qrcode_type(): any {
    const encoded = this.sessionSt.retrieve('sessionst_qrcode_type');
    let decoded = null;
    if (encoded) {
      decoded = JSON.parse(Base64.decode(encoded));
    }
    return decoded;
  }
  set sessionSt_qrcode_type(value) {
    var encoded = Base64.encode(JSON.stringify(value));
    this.sessionSt.store('sessionst_qrcode_type', encoded);
  }

  get sessionSt_scanned_entry(): any {
    const encoded = this.sessionSt.retrieve('sessionst_scannedentry');
    let decoded = null;
    if (encoded) {
      decoded = JSON.parse(Base64.decode(encoded));
    }
    return decoded;
  }
  set sessionSt_scanned_entry(value) {
    var encoded = Base64.encode(JSON.stringify(value));
    this.sessionSt.store('sessionst_scannedentry', encoded);
  }

  get sessionSt_item_list(): any {
    const encoded = this.sessionSt.retrieve('sessionst_itemlist');
    let decoded = null;
    if (encoded) {
      decoded = JSON.parse(Base64.decode(encoded));
    }
    return decoded;
  }
  set sessionSt_item_list(value) {
    var encoded = Base64.encode(JSON.stringify(value));
    this.sessionSt.store('sessionst_itemlist', encoded);
  }

  get sessionSt_category_selected(): any {
    const encoded = this.sessionSt.retrieve('sessionst_category_selected');
    let decoded = null;
    if (encoded) {
      decoded = JSON.parse(Base64.decode(encoded));
    }
    return decoded;
  }
  set sessionSt_category_selected(value) {
    var encoded = Base64.encode(JSON.stringify(value));
    this.sessionSt.store('sessionst_category_selected', encoded);
  }

  get sessionSt_item_selected(): any {
    const encoded = this.sessionSt.retrieve('sessionst_itemselected');
    let decoded = null;
    if (encoded) {
      decoded = JSON.parse(Base64.decode(encoded));
    }
    return decoded;
  }
  set sessionSt_item_selected(value) {
    var encoded = Base64.encode(JSON.stringify(value));
    this.sessionSt.store('sessionst_itemselected', encoded);
  }

  get sessionSt_dinein_paylater(): any {
    const encoded = this.sessionSt.retrieve('sessionst_dinein_paylater');
    let decoded = null;
    if (encoded) {
      decoded = JSON.parse(Base64.decode(encoded));
    }
    return decoded;
  }
  set sessionSt_dinein_paylater(value) {
    var encoded = Base64.encode(JSON.stringify(value));
    this.sessionSt.store('sessionst_dinein_paylater', encoded);
  }

  get sessionSt_cart_item(): any {
    const encoded = this.sessionSt.retrieve('sessionst_cartitem');
    let decoded = null;
    if (encoded) {
      decoded = JSON.parse(Base64.decode(encoded));
    }
    return decoded;
  }
  set sessionSt_cart_item(value) {
    var encoded = Base64.encode(JSON.stringify(value));
    this.sessionSt.store('sessionst_cartitem', encoded);
  }

  get sessionSt_call_categoryitems(): any {
    return this.sessionSt.retrieve('sessionst_call_categoryitems');
  }
  set sessionSt_call_categoryitems(value) {
    this.sessionSt.store('sessionst_call_categoryitems', value);
  }

  get sessionSt_status_companyid(): any {
    const encoded = this.sessionSt.retrieve('sessionst_statuscompanyid');
    let decoded = null;
    if (encoded) {
      decoded = JSON.parse(Base64.decode(encoded));
    }
    return decoded;
  }
  set sessionSt_status_companyid(value) {
    var encoded = Base64.encode(JSON.stringify(value));
    this.sessionSt.store('sessionst_statuscompanyid', encoded);
  }

  get sessionSt_status_companyids(): any {
    // const encoded = this.sessionSt.retrieve('sessionSt_status_companyids');
    // let decoded = null;
    // if (encoded) {
    //   decoded = JSON.parse(Base64.decode(encoded));
    // }
    // return decoded;

    const encoded = this.localSt.retrieve('sessionSt_status_companyids');
    let decoded = null;    
    if (encoded) {
      try {
        const wrapper = JSON.parse(Base64.decode(encoded));
        const now = new Date().getTime();

        if (wrapper.expiresAt && now > wrapper.expiresAt) {
          // Check expires
          this.localSt.clear('sessionSt_status_companyids');
          return null;
        }

        decoded = wrapper.data;
      } catch (e) {
        // Delete
        this.localSt.clear('sessionSt_status_companyids');
      }
    }

    return decoded;
  }
  set sessionSt_status_companyids(value) {
    // var encoded = Base64.encode(JSON.stringify(value));
    // this.sessionSt.store('sessionSt_status_companyids', encoded);

     const now = new Date().getTime();

    // 1 min (60 * 1000 ms)
    //const expiresInMs = 1 * 60 * 1000; //1 min
    const expiresInMs = 4 * 60 * 60 * 1000; // 1 hour
    // const expiresInMs = 2 * 60 * 60 * 1000; // 2 hours
    // const expiresInMs = 24 * 60 * 60 * 1000; // 1 day

    const wrapper = {
      data: value,
      expiresAt: now + expiresInMs
    };

    const encoded = Base64.encode(JSON.stringify(wrapper));
    this.localSt.store('sessionSt_status_companyids', encoded);
  }

  get sessionSt_serviceid(): any {
    const encoded = this.sessionSt.retrieve('sessionst_serviceid');
    let decoded = null;
    if (encoded) {
      decoded = JSON.parse(Base64.decode(encoded));
    }
    return decoded;
  }
  set sessionSt_serviceid(value) {
    var encoded = Base64.encode(JSON.stringify(value));
    this.sessionSt.store('sessionSt_serviceid', encoded);
  }

  get sessionSt_status_serviceid(): any {
    const encoded = this.sessionSt.retrieve('sessionst_statusserviceid');
    let decoded = null;
    if (encoded) {
      decoded = JSON.parse(Base64.decode(encoded));
    }
    return decoded;
  }
  set sessionSt_status_serviceid(value) {
    var encoded = Base64.encode(JSON.stringify(value));
    this.sessionSt.store('sessionSt_statusserviceid', encoded);
  }

  get sessionSt_distance_calculated(): any {
    return this.sessionSt.retrieve('sessionst_distancecalculated');
  }
  set sessionSt_distance_calculated(value) {
    this.sessionSt.store('sessionst_distancecalculated', value);
  }

  get sessionSt_guest(): any {
    return this.sessionSt.retrieve('sessionst_guest');
  }
  set sessionSt_guest(value) {
    this.sessionSt.store('sessionst_guest', value);
  }

  get sessionSt_order_count(): any {
    const encoded = this.sessionSt.retrieve('sessionst_ordercount');
    let decoded = null;
    if (encoded) {
      decoded = JSON.parse(Base64.decode(encoded));
    }
    return decoded;
  }
  set sessionSt_order_count(value) {
    var encoded = Base64.encode(JSON.stringify(value));
    this.sessionSt.store('sessionst_ordercount', encoded);
  }

  get sessionSt_active_category(): any {
    const encoded = this.sessionSt.retrieve('sessionst_activecategory');
    let decoded = null;
    if (encoded) {
      decoded = JSON.parse(Base64.decode(encoded));
    }
    return decoded;
  }
  set sessionSt_active_category(value) {
    var encoded = Base64.encode(JSON.stringify(value));
    this.sessionSt.store('sessionst_activecategory', encoded);
  }

  get sessionSt_qr_code_scanned(): any {
    const encoded = this.sessionSt.retrieve('sessionst_qrcodescanned');
    let decoded = null;
    if (encoded) {
      decoded = JSON.parse(Base64.decode(encoded));
    }
    return decoded;
  }
  set sessionSt_qr_code_scanned(value) {
    var encoded = Base64.encode(JSON.stringify(value));
    this.sessionSt.store('sessionst_qrcodescanned', encoded);
  }

  get sessionSt_qr_scan_current_page(): any {
    const encoded = this.sessionSt.retrieve('sessionst_qrscancurrentpage');
    let decoded = null;
    if (encoded) {
      decoded = JSON.parse(Base64.decode(encoded));
    }
    return decoded;
  }
  set sessionSt_qr_scan_dininenabled(value) {
    var encoded = Base64.encode(JSON.stringify(value));
    this.sessionSt.store('sessionst_qrscandineinenabled', encoded);
  }

  get sessionSt_cart_location_changed(): any {
    const encoded = this.sessionSt.retrieve('sessionst_cartchangedlocation');
    let decoded = null;
    if (encoded) {
      decoded = JSON.parse(Base64.decode(encoded));
    }
    return decoded;
  }
  set sessionSt_cart_location_changed(value) {
    var encoded = Base64.encode(JSON.stringify(value));
    this.sessionSt.store('sessionst_cartchangedlocation', encoded);
  }

  get sessionSt_qr_scan_dininenabled(): any {
    const encoded = this.sessionSt.retrieve('sessionst_qrscandineinenabled');
    let decoded = null;
    if (encoded) {
      decoded = JSON.parse(Base64.decode(encoded));
    }
    return decoded;
  }
  set sessionSt_qr_scan_collectionenabled(value) {
    var encoded = Base64.encode(JSON.stringify(value));
    this.sessionSt.store('sessionst_qrscancollection', encoded);
  }

  get sessionSt_qr_scan_collectionenabled(): any {
    const encoded = this.sessionSt.retrieve('sessionst_qrscancollection');
    let decoded = null;
    if (encoded) {
      decoded = JSON.parse(Base64.decode(encoded));
    }
    return decoded;
  }
  set sessionSt_qr_scan_current_page(value) {
    var encoded = Base64.encode(JSON.stringify(value));
    this.sessionSt.store('sessionst_qrscancurrentpage', encoded);
  }

  get sessionSt_qr_scan_previous_page(): any {
    const encoded = this.sessionSt.retrieve('sessionst_qrscanpreviouspage');
    let decoded = null;
    if (encoded) {
      decoded = JSON.parse(Base64.decode(encoded));
    }
    return decoded;
  }
  set sessionSt_qr_scan_previous_page(value) {
    var encoded = Base64.encode(JSON.stringify(value));
    this.sessionSt.store('sessionst_qrscanpreviouspage', encoded);
  }

  get sessionSt_store_back(): any {
    const encoded = this.sessionSt.retrieve('sessionst_store_back');
    let decoded = null;
    if (encoded) {
      decoded = JSON.parse(Base64.decode(encoded));
    }
    return decoded;
  }
  set sessionSt_store_back(value) {
    var encoded = Base64.encode(JSON.stringify(value));
    this.sessionSt.store('sessionst_store_back', encoded);
  }

  get sessionSt_voucher(): any {
    const encoded = this.sessionSt.retrieve('sessionst_voucher_applied');
    let decoded = null;
    if (encoded) {
      decoded = JSON.parse(Base64.decode(encoded));
    }
    return decoded;
  }

  set sessionSt_voucher(value) {
    var encoded = Base64.encode(JSON.stringify(value));
    this.sessionSt.store('sessionst_voucher_applied', encoded);
  }

  get sessionSt_store_open_for_orders(): any {
    const encoded = this.sessionSt.retrieve('sessionst_open_for_orders');
    let decoded = null;
    if (encoded) {
      decoded = JSON.parse(Base64.decode(encoded));
    }
    return decoded;
  }
  set sessionSt_store_open_for_orders(value) {
    var encoded = Base64.encode(JSON.stringify(value));
    this.sessionSt.store('sessionst_open_for_orders', encoded);
  }

  get sessionSt_welcome_banner_displayed(): any {
    return this.sessionSt.retrieve('sessionst_welcome_banner_displayed');
  }
  set sessionSt_welcome_banner_displayed(value) {
    this.sessionSt.store('sessionst_welcome_banner_displayed', value);
  }

  get sessionSt_weburl_order(): any {
    return this.sessionSt.retrieve('sessionst_weburl_order');
  }
  set sessionSt_weburl_order(value) {
    this.sessionSt.store('sessionst_weburl_order', value);
  }

  get sessionSt_Current_Order_Count(): any {
    return this.sessionSt.retrieve('sessionst_currentordercount');
  }
  set sessionSt_Current_Order_Count(value) {
    this.sessionSt.store('sessionst_currentordercount', value);
  }

  get sessionSt_Past_Order_Count(): any {
    return this.sessionSt.retrieve('sessionst_pastordercount');
  }
  set sessionSt_Past_Order_Count(value) {
    this.sessionSt.store('sessionst_pastordercount', value);
  }

  get sessionSt_upcoming_reservation_Count(): any {
    return this.sessionSt.retrieve('sessionst_upcomingreservationcount');
  }
  set sessionSt_upcoming_reservation_Count(value) {
    this.sessionSt.store('sessionst_upcomingreservationcount', value);
  }

  get sessionSt_promotion_company(): any {
    return this.sessionSt.retrieve('sessionst_promotioncompany');
  }
  set sessionSt_promotion_company(value) {
    this.sessionSt.store('sessionst_promotioncompany', value);
  }

  get sessionSt_message_closed_today(): any {
    return this.sessionSt.retrieve('sessionst_message_closed_today');
  }
  set sessionSt_message_closed_today(value) {
    this.sessionSt.store('sessionst_message_closed_today', value);
  }

  get sessionSt_message_too_far(): any {
    return this.sessionSt.retrieve('sessionst_message_too_far');
  }
  set sessionSt_message_too_far(value) {
    this.sessionSt.store('sessionst_message_too_far', value);
  }

  get sessionSt_message_delivery_error(): any {
    return this.sessionSt.retrieve('sessionst_message_delivery_error');
  }
  set sessionSt_message_delivery_error(value) {
    this.sessionSt.store('sessionst_message_delivery_error', value);
  }

  get sessionSt_message_collection_error(): any {
    return this.sessionSt.retrieve('sessionst_message_collection_error');
  }
  set sessionSt_message_collection_error(value) {
    this.sessionSt.store('sessionst_message_collection_error', value);
  }

  get sessionSt_message_dinein_error(): any {
    return this.sessionSt.retrieve('sessionst_message_dinein_error');
  }
  set sessionSt_message_dinein_error(value) {
    this.sessionSt.store('sessionst_message_dinein_error', value);
  }

  get sessionSt_company_clicked(): any {
    return this.sessionSt.retrieve('sessionst_company_clicked');
  }
  set sessionSt_company_clicked(value) {
    this.sessionSt.store('sessionst_company_clicked', value);
  }

  get sessionSt_item_clicked(): any {
    return this.sessionSt.retrieve('sessionSt_item_clicked');
  }
  set sessionSt_item_clicked(value) {
    this.sessionSt.store('sessionSt_item_clicked', value);
  }

  get sessionSt_is_session_valid(): any {
    return this.sessionSt.retrieve('sessionSt_is_session_valid');
  }
  set sessionSt_is_session_valid(value) {
    this.sessionSt.store('sessionSt_is_session_valid', value);
  }

  get sessionSt_user_order_reference(): any {
    // const encoded = this.localSt.retrieve('sessionSt_user_order_reference');
    // let decoded = null;
    // if (encoded) {
    //   decoded = JSON.parse(Base64.decode(encoded));
    // }
    // return decoded;

    const encoded = this.localSt.retrieve('sessionSt_user_order_reference');
    let decoded = null;    
    if (encoded) {
      try {
        const wrapper = JSON.parse(Base64.decode(encoded));
        const now = new Date().getTime();

        if (wrapper.expiresAt && now > wrapper.expiresAt) {
          // Check expires
          this.localSt.clear('sessionSt_user_order_reference');
          return null;
        }

        decoded = wrapper.data;
      } catch (e) {
        // Delete
        this.localSt.clear('sessionSt_user_order_reference');
      }
    }

    return decoded;
  }

  set sessionSt_user_order_reference(value) {
    //var encoded = Base64.encode(JSON.stringify(value));
    //this.localSt.store('sessionSt_user_order_reference', encoded);

    const now = new Date().getTime();

    // 1 min (60 * 1000 ms)
    //const expiresInMs = 1 * 60 * 1000; //1 min
    const expiresInMs = 15 * 60 * 60 * 1000; // 1 hour
    // const expiresInMs = 2 * 60 * 60 * 1000; // 2 hours
    // const expiresInMs = 24 * 60 * 60 * 1000; // 1 day

    const wrapper = {
      data: value,
      expiresAt: now + expiresInMs
    };

    const encoded = Base64.encode(JSON.stringify(wrapper));
    this.localSt.store('sessionSt_user_order_reference', encoded);
  }

  get localSt_user_order_giftcard(): any {
    // const encoded = this.localSt.retrieve('localSt_user_order_giftcard');
    // let decoded = null;
    // if (encoded) {
    //   decoded = JSON.parse(Base64.decode(encoded));
    // }
    // return decoded;

    const encoded = this.localSt.retrieve('localSt_user_order_giftcard');
    let decoded = null;    
    if (encoded) {
      try {
        const wrapper = JSON.parse(Base64.decode(encoded));
        const now = new Date().getTime();

        if (wrapper.expiresAt && now > wrapper.expiresAt) {
          // Check expires
          this.localSt.clear('localSt_user_order_giftcard');
          return null;
        }

        decoded = wrapper.data;
      } catch (e) {
        // Delete
        this.localSt.clear('localSt_user_order_giftcard');
      }
    }

    return decoded;
  }

  set localSt_user_order_giftcard(value) {
    //var encoded = Base64.encode(JSON.stringify(value));
    //this.localSt.store('sessionSt_user_order_reference', encoded);

    const now = new Date().getTime();

    // 1 min (60 * 1000 ms)
    //const expiresInMs = 1 * 60 * 1000; //1 min
    const expiresInMs = 15 * 60 * 60 * 1000; // 1 hour
    // const expiresInMs = 2 * 60 * 60 * 1000; // 2 hours
    // const expiresInMs = 24 * 60 * 60 * 1000; // 1 day

    const wrapper = {
      data: value,
      expiresAt: now + expiresInMs
    };

    const encoded = Base64.encode(JSON.stringify(wrapper));
    this.localSt.store('localSt_user_order_giftcard', encoded);
  }

  get sessionSt_user_order_data(): any {
    const encoded = this.localSt.retrieve('sessionSt_user_order_data');
    let decoded = null;
    if (encoded) {
      decoded = JSON.parse(Base64.decode(encoded));
    }
    return decoded;
  }

  set sessionSt_user_order_data(value) {
    var encoded = Base64.encode(JSON.stringify(value));
    this.localSt.store('sessionSt_user_order_data', encoded);
  }

  get sessionSt_discounts(): any {
    const encoded = this.sessionSt.retrieve('sessionst_discounts');
    let decoded = null;
    if (encoded) {
      decoded = JSON.parse(Base64.decode(encoded));
    }
    return decoded;
  }
  set sessionSt_discounts(value) {
    var encoded = Base64.encode(JSON.stringify(value));
    this.sessionSt.store('sessionst_discounts', encoded);
  }

  get sessionSt_user_info(): any {
    const encoded = this.sessionSt.retrieve('sessionst_userinfo');
    let decoded = null;
    if (encoded) {
      decoded = JSON.parse(Base64.decode(encoded));
    }
    return decoded;
  }
  set sessionSt_user_info(value) {
    var encoded = Base64.encode(JSON.stringify(value));
    this.sessionSt.store('sessionst_userinfo', encoded);
  }


  DecodeValue(value) {
    let decoded = null;
    if (value) {
      decoded = JSON.parse(Base64.decode(value));
    }
    return decoded;
  }
}
